import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "400px",
    overflow: "hidden",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
  },
  content: {
    flex: 1,
    overflowY: "auto",
    padding: theme.spacing(2),
  },
  contentBlurred: {
    filter: "blur(2px)",
    pointerEvents: "none",
  },
  addNoteFormSection: {
    padding: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
    boxShadow: "0 -4px 12px rgba(0,0,0,0.08)",
    "--animate-duration": "0.3s",
    backfaceVisibility: "hidden",
  },
  footer: {
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
    minHeight: 52,
    alignItems: "center",
  },
  footerButtons: {
    display: "flex",
    gap: theme.spacing(1),
    "--animate-duration": "0.2s",
    backfaceVisibility: "hidden",
  },
  errorContainer: {
    textAlign: "center",
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}));
